import React from 'react'
import { Navigate } from 'react-router-dom'

import { LoadFailure } from 'components/LoadFailure'
import { userContext } from 'context/user'
import { routes } from 'routes'


export function PrivateRoute({component}: {component: React.ReactNode}) {
  const user = React.useContext(userContext)

  // Must precede the !user.data check below. A failed currentUser query also
  // leaves data undefined, so without this a dropped connection would read as
  // "not authenticated" and bounce a signed-in user to the login page.
  if (user.failure) return <LoadFailure onRetry={() => user.refetch()} />
  if (user.spinner) return user.spinner
  if (!user.data) return <Navigate to={routes.LOGIN} />

  return component
}
